export const oskarWorks = {
  album: [
    {
      id: 2,
      title: 'Real Fun, Wow! (feat. Daren)',
      year: '2025.12.01.',
      image: require('./album/real-fun-wow.webp'),
      link: 'https://music.bugs.co.kr/track/6382497?wl_ref=list_tr_08',
    },
    {
      id: 1,
      title: 'Can’t Funk With Us (Original Mix)',
      year: '2018',
    },
  ],
};
